import { TimePickerProps } from 'core/time-picker/time-picker.types';

export const TimePickerPresets: TimePickerProps = {
  hour: '12',
  meridiem: 'AM',
  minute: '00',
};
